import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';

import Select2 from 'react-select2-wrapper';

import PageHeader from '../elements/PageHeader';
import AddDialog from "../elements/supporterList/AddDialog";
import NameHelper from '../../helpers/nameHelper';

class SupporterListScreen extends Component {
    constructor(props) {
        super(props);

        this.handlePaginatePrev = this.handlePaginatePrev.bind(this);
        this.handlePaginateNext = this.handlePaginateNext.bind(this);
        this.handleSearchStringChange = this.handleSearchStringChange.bind(this);
        this.handlePeriodsFilterChange = this.handlePeriodsFilterChange.bind(this);
        this.handleStatesFilterChange = this.handleStatesFilterChange.bind(this);
        this.handleOpenSupporter = this.handleOpenSupporter.bind(this);
        this.filterByGroup = this.filterByGroup.bind(this);
    }

    componentDidMount() {
        this.props.getSupporters();
    }

    handleSupporterCreated = () => {
        this.props.getSupporters();
    };

    handlePaginatePrev() {
        this.props.paginate(-1);
    }

    handlePaginateNext() {
        this.props.paginate(1);
    }

    handleSearchStringChange(e) {
        this.props.searchStringChange(e.target.value);
    }

    handleStatesFilterChange(e) {
        this.props.statesFilterChange([...e.target.options].filter(({selected}) => selected).map(({value}) => value));
    }

    handlePeriodsFilterChange(e) {
        this.props.periodsFilterChange([...e.target.options].filter(({selected}) => selected).map(({value}) => value));
    }

    handleOpenSupporter(e) {
        let supporterId;
        if(e.target.tagName.toLowerCase() === 'a') return;
        if(e.target.tagName.toLowerCase() === 'td') {
            supporterId = e.target.parentNode.getAttribute('data-supporter-id');
        } else {
            supporterId = e.target.getAttribute('data-supporter-id');
        }
        this.props.history.push("/supporter/" + supporterId);
    }

    filterByGroup(groupName) {
        this.props.searchStringChange(groupName);
        this.props.statesFilterChange([]);
        this.props.periodsFilterChange([]);
    }

    render() {
        const {t, supporters, pagination, visibileSupportersAmount, availableStates, availablePeriods, statesFilter, periodsFilter} = this.props;
        let visibleSupporters = supporters.filter(function (supporter) {
            return supporter.visible
        });
        return (
            <div className="SupporterListScreen">
                <PageHeader title={t('supporterList.title')}/>
                <div className="row m-t m-b">
                    <div className="col-md-4">
                        <input type="text" name="searchString" onChange={this.handleSearchStringChange}
                               className="form-control form-control-lg block"
                               placeholder={t('supporterList.search.placeholder')} value={this.props.searchString}/>
                    </div>
                    <div className="col-md-4">
                        <Select2 multiple data={availableStates} ref={(e) => { this.tags = e; }} value={statesFilter} onChange={this.handleStatesFilterChange} options={{placeholder: t('supporterList.state.placeholder')}} className="width-100p block"/>
                    </div>
                    <div className="col-md-4">
                        <Select2 multiple data={availablePeriods.map((el) => {
                            return {
                                text: t('default.period.' + el.period, {
                                    startAt: moment(el.periodStartAt).format('DD.MM.'),
                                    endAt: moment(el.periodEndAt).format('DD.MM.')
                                }), id: el.period
                            }
                        })} value={periodsFilter} onChange={this.handlePeriodsFilterChange}
                                 options={{placeholder: t('supporterList.period.placeholder')}}
                                 className="width-100p block"/>
                    </div>
                </div>
                <table className="table table-hover cursor-pointer m-t">
                    <thead>
                    <tr>
                        <th>
                            {t('supporterList.table.name')}
                        </th>
                        <th>
                            {t('supporterList.table.email')}
                        </th>
                        <th>
                            {t('supporterList.table.group')}
                        </th>
                        <th>
                            {t('supporterList.table.stateForCurrentProject')}
                        </th>
                        <th>
                            {t('supporterList.table.periodForCurrentProject')}
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {visibleSupporters.slice((pagination.entrysPerPage * pagination.currentPage), (pagination.entrysPerPage * pagination.currentPage) + pagination.entrysPerPage).map((supporter) => {
                        return (
                            <tr key={supporter.id} onClick={this.handleOpenSupporter} data-supporter-id={supporter.id} style={supporter.sojusProjectCrew ? {background: '#8fdc8f'} : supporter.availableAsSteward ? {background: '#ffbb73'} : supporter.availableForBottleDeposit ? {background: '#c6caff'} : {}}>
                                <td>
                                    {NameHelper.displayName(supporter)}
                                </td>
                                <td>
                                    {supporter.email}
                                </td>
                                <td>
                                    <a onClick={() => (this.filterByGroup(supporter.groupName))}>
                                        {supporter.groupName}
                                    </a>
                                </td>
                                <td>
                                    {supporter.state}
                                </td>
                                <td>
                                    {supporter.period ? t('default.period.' + supporter.period, {
                                        startAt: moment(supporter.periodStartAt).format('DD.MM.'),
                                        endAt: moment(supporter.periodEndAt).format('DD.MM.')
                                    }) : null}
                                </td>
                                <td></td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                <div>
                    <div className="pull-right m-t-md">
                        <AddDialog onSupporterCreated={this.handleSupporterCreated} />
                    </div>
                    { visibleSupporters.length > 0 ? (
                        <div className="pagination">
                            <button className="btn btn-default m-r" disabled={pagination.currentPage === 0}
                                    onClick={this.handlePaginatePrev}>
                                <i className="fa fa-arrow-left"/>
                            </button>
                            {pagination.currentPage + 1} / {Math.ceil(visibileSupportersAmount / pagination.entrysPerPage)}
                            <button className="btn btn-default m-l"
                                    disabled={(pagination.currentPage + 1) >= Math.ceil(visibileSupportersAmount / pagination.entrysPerPage)}
                                    onClick={this.handlePaginateNext}>
                                <i className="fa fa-arrow-right"/>
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="count m-b">
                    { visibleSupporters.length } {t('supporterList.visibleEntrys')}
                </div>
            </div>
        )
    }
}

export default translate()(SupporterListScreen);